/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed May 11 2022
*  File : DefaultGuiServiceInjector.ts
*******************************************/

import { CatalogueLanguages, CatalogueManager, StaticCatalogueManager } from "@ciaopeople/cp-shatsu/Catalogue";
import { GuiServicesInjector } from "../GuiServicesInjector.js";
import { PropertyConfig } from "../../config/PropertyConfig.js";
import { StatsCollector } from "../../stats/StatsCollector.js";

export class DefaultGuiServiceInjector implements GuiServicesInjector {
    private catalogue: CatalogueManager;

    constructor(
        locale: CatalogueLanguages,
        private propConfig: PropertyConfig,
        private statsCollector: StatsCollector
    ) {
        this.catalogue = new StaticCatalogueManager(locale);
    }
    getPropertyConfig(): PropertyConfig {
        return this.propConfig;
    }

    getCatalogueManager(): CatalogueManager {
        return this.catalogue;
    }

    getStatsCollector(): StatsCollector {
        return this.statsCollector;
    }
}